import { QueryHookOptions } from '@apollo/client';
import { useInfiniteQuery } from 'hooks/useInfiniteQuery';
import getPlatformAccountsQuery from '../../../Fleets/hooks/managedPlatformAccountsQuery.graphql';

export const useManagedPlatformAccountsQuery = (
  options: QueryHookOptions<
    ManagedPlatformAccountsQuery,
    QueryManagedPlatformAccountsArgs
  >,
) => {
  return useInfiniteQuery<
    ManagedPlatformAccountsQuery,
    QueryManagedPlatformAccountsArgs
  >(getPlatformAccountsQuery, {
    fieldName: 'managedPlatformAccounts',
    ...options,
  });
};
